import { render, staticRenderFns } from "./AppProgress.vue?vue&type=template&id=70b22ab4&scoped=true"
import script from "./AppProgress.vue?vue&type=script&lang=js"
export * from "./AppProgress.vue?vue&type=script&lang=js"
import style0 from "./AppProgress.vue?vue&type=style&index=0&id=70b22ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b22ab4",
  null
  
)

export default component.exports